import { REMARK_CHANGE, REMARK_INIT } from '../constants/ActionTypes';

function getInitRemarkAction({ flowId }) {
  return {
    type: REMARK_INIT,
    payload: {
      flowId
    }
  }
}

function getChangeRemarkAction(payload) {
  return {
    type: REMARK_CHANGE,
    payload
  }
}


export default {
  getInitRemarkAction,
  getChangeRemarkAction,
}